import React, { useState, useEffect, useCallback } from 'react';
import { 
  Container, 
  Row, 
  Col, 
  Form, 
  Button, 
  InputGroup, 
  Table, 
  Nav,
  Card,
  Badge,
  ListGroup
} from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import swal from 'sweetalert';
import Loader from './LoaderModal';
import Side from './Sidebar';
import Top from './Topbar';
import C from '../lib/Config';
import '../App.css';

// Ensure process is defined for environment checks
if (typeof process === 'undefined') {
  global.process = { 
    env: { 
      NODE_ENV: 'development' 
    } 
  };
}

const AddInvoice = () => {
  const history = useHistory();
  
  // List of consultants
  const consultants = [
    'Dr. Rajesh Kumar', 'Dr. Priya Sharma', 'Dr. Amit Patel', 
    'Dr. Neha Gupta', 'Dr. Sanjay Mehta', 'Dr. Anita Singh', 
    'Dr. Vikram Reddy', 'Dr. Deepa Chatterjee', 'Dr. Rahul Khanna', 
    'Dr. Meena Iyer'
  ];

  // Department options
  const departments = ['OPD', 'IPD', 'Daycare', 'Pharmacy'];

  // Payment methods
  const paymentMethodOptions = [
    'Cash', 'UPI', 'Card', 'Cheque', 'Insurance', 
    'RTGS', 'MOCF', 'Writeoff', 'NEFT'
  ];

  // Discount reasons
  const discountReasons = [
    'Poor Patient', 
    'As per Consultant Doctor', 
    'As per Referring Doctor', 
    'C/o staff', 
    'Patient dr himself/herself', 
    'Staff'
  ];

  const [patientSearchResults, setPatientSearchResults] = useState([]);

  const [formSubmitted, setFormSubmitted] = useState(false);
  // State initialization

  const [errors, setErrors] = useState({
    invoiceDate: '',
    patientName: '',
    primaryConsultant: '',
    department: '',
    visitDate: '',
    admission_Date: ''
  });

  const [formState, setFormState] = useState({
    invoiceDate: '',
    visitDate: '',
    admission_Date: '',
    discharge_Date: '',
    patientName: '',
    patientId: '',
    primaryConsultant: '',
    department: '',
    vendor: '',
    comments: '',
    
    // Filtering and selection states
    activeTab: 'services',
    category: '',
    searchTerm: '',
    discountType: 'percentage',
    // Items and pricing
    selectedServices: [],
    selectedPackages: [],
    
    // Discount
    showDiscount: false,
    discountPercent: 0,
    discountAmount: '',
    discountReason: '',
    
    // Payment methods
    paymentMethods: [{ 
      method: '', 
      amount: '', 
      note: '', 
      date: '' 
    }],
    
    // Mode and loading
    isEditMode: false,
    loading: false,
    error: null
  });

  /// Categories state 
const [serviceCategories, setServiceCategories] = useState([]);
const [packageCategories, setPackageCategories] = useState([]);
// State for vendors
const [vendors, setVendors] = useState([]);


// Fetch methods with implementation
const fetchServicesByCategory = useCallback((category) => {
  console.log(`Filtering services for category: ${category}`);
  
  // If no category provided, show all services
  if (!category) {
    return;
  }

  // Filter services from the current state
  const filteredServices = serviceCategories.filter(
    cat => cat.name.toLowerCase() === category.toLowerCase()
  );

  // If no matching category found, fetch all services again
  if (filteredServices.length === 0) {
    fetchAllServiceInvoices();
  } else {
    setServiceCategories(filteredServices);
  }
}, [serviceCategories]);

const fetchPackagesByCategory = useCallback((category) => {
  console.log(`Filtering packages for category: ${category}`);
  
  // If no category provided, show all packages
  if (!category) {
    return;
  }

  // Filter packages from the current state
  const filteredPackages = packageCategories.filter(
    cat => cat.name.toLowerCase() === category.toLowerCase()
  );

  // If no matching category found, fetch all packages again
  if (filteredPackages.length === 0) {
    fetchAllPackageInvoices();
  } else {
    setPackageCategories(filteredPackages);
  }
}, [packageCategories]);

  const fetchPatientData = useCallback((name) => {
    console.log(`Fetching patient data for: ${name}`);
    const mockPatientId = name.replace(/\s/g, '').toUpperCase().substring(0, 6);
    setFormState(prev => ({
      ...prev,
      patientId: mockPatientId
    }));
  }, []);

  // Effect hook to initialize data
  useEffect(() => {
    const today = new Date();
    const formattedDate = formatDate(today);

    // Set initial dates
    setFormState(prev => ({
      ...prev,
      invoiceDate: formattedDate,
      visitDate: formattedDate
    }));

    // Check for edit mode
    const params = new URLSearchParams(window.location.search);
    const invoiceNumberParam = params.get('invoiceNumber');
    
    if (invoiceNumberParam) {
      fetchInvoiceDetails(invoiceNumberParam);
    }

    // Fetch services and packages
    fetchAllServiceInvoices();
    fetchAllPackageInvoices();
     // Fetch vendors
     fetchVendors();
  }, []);

  // Utility Functions
  const formatDate = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  };

  // const getMinDate = () => {
  //   return formatDate(new Date());
  // };
// Updated implementation - remove date restriction
const getMinDate = () => {
  // Return a date far in the past to effectively remove the minimum date restriction
  return "1900-01-01"; // This effectively removes the restriction
};
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    
 // Special handling for vendor changes
 if (name === 'vendor') {
  console.log(`Vendor changed to: ${value}`); // For debugging
  setFormState(prev => ({
    ...prev,
    [name]: value,
    // Optionally reset other filters when changing vendor
    // category: '',  // Uncomment if you want to reset category when vendor changes
    // searchTerm: '' // Uncomment if you want to reset search when vendor changes
  }));
  return;
}

    // Special handling for department changes
    if (name === 'department') {
      if (value === 'IPD') {
        // For IPD, initialize admission and discharge dates if empty
        setFormState(prev => ({
          ...prev,
          [name]: value,
          // Set admission_Date to current visitDate if it exists, otherwise today's date
          admission_Date: prev.visitDate || formatDate(new Date()),
          // Discharge date can be empty initially
          discharge_Date: '',
          // Keep visitDate for internal tracking
          visitDate: prev.visitDate || formatDate(new Date())
        }));
      } else if (value === 'OPD') {
        // For OPD, ensure visitDate is set, but clear admission/discharge dates
        setFormState(prev => ({
          ...prev,
          [name]: value,
          visitDate: prev.visitDate || formatDate(new Date()),
          // Clear IPD related fields
          admission_Date: '',
          discharge_Date: ''
        }));
      } else {
        // For other departments, just update the department
        setFormState(prev => ({
          ...prev,
          [name]: value
        }));
      }
      return;
    }
    
    // Special handling for discount fields to auto-calculate
    if (name === 'discountPercent') {
      // Discount percentage handling code...
      // Allow empty field but use 0 for calculations
      if (value === '') {
        setFormState(prev => ({
          ...prev,
          discountPercent: '',
          discountAmount: ''
        }));
        return;
      }
      
      // Handle invalid values
      if (isNaN(parseFloat(value))) {
        setFormState(prev => ({
          ...prev,
          discountPercent: '',
          discountAmount: ''
        }));
        return;
      }
      
      const totalAmount = calculateTotalAmount();
      const discountAmount = (parseFloat(value) / 100) * totalAmount;
      
      setFormState(prev => ({
        ...prev,
        discountPercent: value,
        discountAmount: discountAmount.toFixed(2)
      }));
    } else if (name === 'discountAmount') {
      // Discount amount handling code...
      // Allow empty field but use 0 for calculations
      if (value === '') {
        setFormState(prev => ({
          ...prev,
          discountAmount: '',
          discountPercent: ''
        }));
        return;
      }
      
      // Handle invalid values
      if (isNaN(parseFloat(value))) {
        setFormState(prev => ({
          ...prev,
          discountAmount: '',
          discountPercent: ''
        }));
        return;
      }
      
      const totalAmount = calculateTotalAmount();
      // Avoid division by zero
      if (totalAmount > 0) {
        const discountPercent = (parseFloat(value) / totalAmount) * 100;
        
        setFormState(prev => ({
          ...prev,
          discountAmount: value,
          discountPercent: discountPercent.toFixed(2)
        }));
      } else {
        // If total amount is zero, just update the amount field
        setFormState(prev => ({
          ...prev,
          discountAmount: value
        }));
      }
    } else {
      // Default behavior for other fields
      setFormState(prev => ({
        ...prev,
        [name]: value
      }));
    }
  
    // IMPORTANT: Handle additional field-specific logic
    // This is the part that was missing and caused the patient search API to stop working
    if (name === 'patientName') {
      if (value.length > 1) {
        searchPatients(value);
      } else {
        setPatientSearchResults([]);
      }
    } else if (name === 'category') {
      if (formState.activeTab === 'services') {
        fetchServicesByCategory(value);
      } else {
        fetchPackagesByCategory(value);
      }
    }
  };


  const handleItemDiscountTypeChange = (index, type) => {
    setFormState(prev => {
      const updatedServices = [...prev.selectedServices];
      
      // Initialize item.discountType if not already set
      if (!updatedServices[index].item.discountType) {
        updatedServices[index].item = {
          ...updatedServices[index].item,
          discountType: type
        };
      } else {
        // Update the existing discount type
        updatedServices[index].item.discountType = type;
      }
      
      // If switching between types, recalculate discount amount or percentage
      const price = updatedServices[index].item.price || 0;
      const quantity = updatedServices[index].item.quantity || 1;
      const discountValue = updatedServices[index].item.discount || 0;
      
      // Calculate total discount amount in rupees
      let discountAmount = 0;
      
      // Convert discount based on the new type
      if (type === 'percentage') {
        // If changing to percentage, calculate percentage from fixed amount
        if (price * quantity > 0) {
          updatedServices[index].item.discount = (discountValue / (price * quantity)) * 100;
          discountAmount = discountValue; // Keep the same amount
        }
      } else {
        // If changing to fixed, calculate fixed amount from percentage
        discountAmount = (price * quantity * discountValue) / 100;
        updatedServices[index].item.discount = discountAmount;
      }
      
      // Store total discount in rupees
      updatedServices[index].item.totalDiscount = discountAmount.toFixed(2);
      
      // Recalculate charges
      recalculateItemCharges(updatedServices, index, prev.showDiscount, prev.discountPercent);
      
      return {
        ...prev,
        selectedServices: updatedServices
      };
    });
  };

  const handleDiscountTypeChange = (type) => {
    setFormState(prev => {
      // First calculate the subtotal after item-specific discounts
      let subtotal = 0;
      prev.selectedServices.forEach(service => {
        const price = service.item.price || 0;
        const quantity = service.item.quantity || 1;
        const baseTotal = price * quantity;
        let itemTotal = baseTotal;
        
        // Apply item-specific discount
        if (service.item.discount) {
          const discountType = service.item.discountType || 'percentage';
          if (discountType === 'percentage') {
            const discountAmount = (baseTotal * service.item.discount) / 100;
            itemTotal = baseTotal - discountAmount;
          } else {
            itemTotal = baseTotal - Math.min(service.item.discount, baseTotal);
          }
        }
        
        subtotal += itemTotal;
      });
      
      let discountPercent = prev.discountPercent;
      let discountAmount = prev.discountAmount;
      
      // Calculate the equivalent value when switching types
      if (type === 'percentage' && prev.discountType === 'fixed') {
        // Convert fixed amount to percentage
        if (subtotal > 0 && discountAmount) {
          discountPercent = ((parseFloat(discountAmount) / subtotal) * 100).toFixed(2);
        }
      } else if (type === 'fixed' && prev.discountType === 'percentage') {
        // Convert percentage to fixed amount
        if (discountPercent) {
          discountAmount = ((parseFloat(discountPercent) / 100) * subtotal).toFixed(2);
        }
      }
      
      return {
        ...prev,
        discountType: type,
        discountPercent: type === 'percentage' ? discountPercent : prev.discountPercent,
        discountAmount: type === 'fixed' ? discountAmount : prev.discountAmount
      };
    });
  };

  const selectPatient = (patient) => {
    setFormState(prev => ({
      ...prev,
      patientName: `${patient.patientName} - ${patient.phoneNumber} - ${patient.caseId}`,
      patientId: patient.patientId,
      phoneNumber: patient.phoneNumber,
    }));
    setPatientSearchResults([]);
  };


  const searchPatients = async (searchTerm) => {
    if (searchTerm.length < 2) {
      setPatientSearchResults([]);
      return;
    }
    
    try {
      // Get doctorId from localStorage instead of hardcoded value
      const doctorId = localStorage.getItem("userId") || "";
      
      const response = await fetch(`${C.getUrl()}/userCase/getPatientRegistrationList?doctorId=${doctorId}&status=A`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch patients');
      }
      
      const data = await response.json();
      let patients = [];
      
      if (data.statusCode === 200 && data.message) {
        try {
          patients = JSON.parse(data.message);
          // Filter patients by name, ID, or phone number
          patients = patients.filter(patient => 
            patient.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            patient.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            patient.phoneNumber1.toString().includes(searchTerm) ||
            patient.caseId.toLowerCase().includes(searchTerm.toLowerCase())
          ).map(patient => ({
            patientName: `${patient.firstName} ${patient.lastName}`,
            patientId: patient.patientID,
            phoneNumber: patient.phoneNumber1,
            caseId: patient.caseId
          }));
        } catch (e) {
          console.error('Error parsing patient data:', e);
        }
      }
      
      setPatientSearchResults(patients);
    } catch (error) {
      console.error('Error searching patients:', error);
      setPatientSearchResults([]);
    }
  };

// Add this function to group packages by their headings
const renderPackageHeadings = () => {
  // Get original package categories
  let packageCats = packageCategories || [];
  
  // Apply filters if any
  if (formState.category) {
    packageCats = packageCats.filter(
      cat => cat.name.toLowerCase() === formState.category.toLowerCase()
    );
  }

  if (formState.searchTerm) {
    packageCats = packageCats.map(category => ({
      ...category,
      items: category.items.filter(item => 
        item.name.toLowerCase().includes(formState.searchTerm.toLowerCase())
      )
    })).filter(cat => cat.items.length > 0);
  }

  // Group by unique heading names
  const uniqueHeadings = [...new Set(packageCats.map(cat => cat.name))];
  
  return uniqueHeadings.map(heading => {
    // Get all items under this heading
    const items = packageCats
      .filter(cat => cat.name === heading)
      .flatMap(cat => cat.items || []);
      
    return {
      heading,
      items
    };
  });
};

// Add this function to handle selecting all packages under a heading
const handleSelectAllPackages = (heading, items) => {
  // Add all items in this group to the selected services
  items.forEach(item => {
    const newItem = {
      name: heading,
      item: {
        name: item.name,
        price: item.price,
        quantity: 1,
        tax: 0,
        charges: item.price
      }
    };
    
    // Check if this item is already selected
    const exists = formState.selectedServices.some(
      service => service.item.name === newItem.item.name && service.name === newItem.name
    );
    
    if (!exists) {
      setFormState(prev => ({
        ...prev,
        selectedServices: [...prev.selectedServices, newItem]
      }));
    }
  });
};


const fetchInvoiceDetails = async (invoiceNumber) => {
  try {
    setFormState(prev => ({ ...prev, loading: true }));
    
    const response = await fetch(`${C.getUrl()}/invoice/getByInvoiceNumber/${invoiceNumber}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch invoice details');
    }

    const apiResponse = await response.json();
    
    if (apiResponse.httpStatusCode === 200 && apiResponse.subErrors && apiResponse.subErrors.length > 0) {
      let invoiceData;
      try {
        invoiceData = JSON.parse(apiResponse.subErrors[0]);
      } catch (e) {
        console.error('Error parsing invoice data:', e);
        throw new Error('Invalid invoice data format');
      }
      
      // Get items and payments for this invoice
      const itemsPromise = fetchItems(invoiceNumber);
      const paymentsPromise = fetchPayments(invoiceNumber);
      
      const [items, payments] = await Promise.all([itemsPromise, paymentsPromise]);
      
      // Date conversion helper
      const convertAPIDateToUIDate = (dateStr) => {
        if (!dateStr) return '';
        
        if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
          return dateStr; 
        }
        
        if (dateStr.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
          const [day, month, year] = dateStr.split('/');
          return `${year}-${month}-${day}`;
        }
        
        return dateStr;
      };
      
      // Map backend data to frontend format with correct discount field mapping
      const selectedServices = items.map(item => {
        // Determine the item's discount type and value
        let itemDiscountType = 'percentage';
        let itemDiscountValue = 0;
        
        // Check itemPType and itemRType to determine discount type
        if (item.itemPType === "%" && item.itemP) {
          itemDiscountType = 'percentage';
          itemDiscountValue = item.itemP;
        } else if (item.itemRType === "₹" && item.itemR) {
          itemDiscountType = 'fixed';
          itemDiscountValue = item.itemR;
        } else {
          // Fallback: check standard discount field
          itemDiscountValue = item.discount || 0;
        }
        
        return {
          name: item.category || 'Service',
          item: {
            name: item.item,
            price: item.costPerUnit,
            quantity: item.quantity || 1,
            discount: itemDiscountValue,
            discountType: itemDiscountType,
            tax: item.tax || 0,
            charges: item.netAmount || (item.costPerUnit * (item.quantity || 1))
          }
        };
      });

      const paymentMethods = payments.length > 0 ? payments.map(payment => ({
        method: payment.paymentMethod,
        amount: payment.paymentAmount.toString(),
        note: payment.otherNote || '',
        date: convertAPIDateToUIDate(payment.paymentDate) || convertAPIDateToUIDate(invoiceData.invoiceDate)
      })) : [{ method: '', amount: '', note: '', date: '' }];
      
      // Determine global discount type and value from the specific fields
      let discountType = 'percentage';
      let discountPercent = 0;
      let discountAmount = 0;
      
      // Check for percentage discount
      if (invoiceData.invoicePType === "Percentage(%)") {
        discountType = 'percentage';
        discountPercent = invoiceData.dpercentag || 0;
      } 
      // Check for fixed amount discount
      else if (invoiceData.invoiceRType === "Fixed amount") {
        discountType = 'fixed';
        discountAmount = invoiceData.invoiceR || invoiceData.discount || 0;
      }
      // Fallback to the general fields
      else if (invoiceData.dpercentag > 0) {
        discountType = 'percentage';
        discountPercent = invoiceData.dpercentag;
      } else if (invoiceData.discount > 0) {
        discountType = 'fixed';
        discountAmount = invoiceData.discount;
      }
      
      // Update form state with fetched invoice details
      setFormState(prev => ({
        ...prev,
        invoiceDate: convertAPIDateToUIDate(invoiceData.invoiceDate),
        patientName: invoiceData.patientName,
        patientId: invoiceData.patientId,
        primaryConsultant: invoiceData.consultant || invoiceData.primaryConsultant,
        department: invoiceData.department,
        comments: invoiceData.comments,
        selectedServices: selectedServices,
        // Set discount with type 
        showDiscount: discountType === 'percentage' ? discountPercent > 0 : discountAmount > 0,
        discountType: discountType,
        discountPercent: discountType === 'percentage' ? discountPercent.toString() : '',
        discountAmount: discountType === 'fixed' ? discountAmount.toString() : '',
        discountReason: invoiceData.disResone || '',
        paymentMethods: paymentMethods,
        isEditMode: true,
        loading: false
      }));
    } else {
      throw new Error(apiResponse.message || 'No invoice data found');
    }
  } catch (error) {
    console.error('Error fetching invoice details:', error);
    setFormState(prev => ({ 
      ...prev, 
      error: error.message,
      loading: false 
    }));
    
    swal({
      title: "Error!",
      text: error.message,
      icon: "error"
    });
  }
};

// Helper function to fetch items for an invoice
const fetchItems = async (invoiceNumber) => {
  try {
    const response = await fetch(`${C.getUrl()}/invoice/item/getByInvoiceNumber/${invoiceNumber}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch invoice items');
    }
    
    const apiResponse = await response.json();
    
    // Parse the response to get the item list
    if (apiResponse.httpStatusCode === 200 && apiResponse.subErrors && apiResponse.subErrors.length > 0) {
      let invoiceData;
      try {
        invoiceData = JSON.parse(apiResponse.subErrors[0]);
        return invoiceData.itemList || [];
      } catch (e) {
        console.error('Error parsing items data:', e);
        return [];
      }
    }
    
    return [];
  } catch (error) {
    console.error('Error fetching items:', error);
    return [];
  }
};

// Helper function to fetch payments for an invoice
const fetchPayments = async (invoiceNumber) => {
  try {
    const response = await fetch(`${C.getUrl()}/invoice/payment/getByInvoiceNumber/${invoiceNumber}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch invoice payments');
    }
    
    const apiResponse = await response.json();
    
    // Parse the response to get the payment list
    if (apiResponse.httpStatusCode === 200 && apiResponse.subErrors && apiResponse.subErrors.length > 0) {
      let invoiceData;
      try {
        invoiceData = JSON.parse(apiResponse.subErrors[0]);
        return invoiceData.paymentList || [];
      } catch (e) {
        console.error('Error parsing payments data:', e);
        return [];
      }
    }
    
    return [];
  } catch (error) {
    console.error('Error fetching payments:', error);
    return [];
  }
};

  // const fetchAllServiceInvoices = async () => {
  //   try {
  //     const response = await fetch(`${C.getUrl()}/service-invoice/getAllServiceInvoices`, {
  //       method: 'GET',
  //       headers: { 'Content-Type': 'application/json' }
  //     });
  
  //     if (!response.ok) {
  //       throw new Error('Failed to fetch services');
  //     }
  
  //     const data = await response.json();
      
  //     // Check if there are services
  //     if (data.subErrors && data.subErrors.length > 0) {
  //       // Parse the JSON string in subErrors
  //       const serviceItems = JSON.parse(data.subErrors[0]);
        
  //       // Group services by category
  //       const categorizedServices = serviceItems.reduce((acc, item) => {
  //         const categoryName = item.category;
  //         if (!acc[categoryName]) {
  //           acc[categoryName] = {
  //             name: categoryName,
  //             items: []
  //           };
  //         }
          
  //         acc[categoryName].items.push({
  //           name: item.item,
  //           price: item.costPerUnit
  //         });
          
  //         return acc;
  //       }, {});
  
  //       // Convert the grouped object to an array
  //       const serviceCategoriesList = Object.values(categorizedServices);
        
  //       setServiceCategories(serviceCategoriesList);
  //     } else {
  //       // Set to empty array if no services found
  //       setServiceCategories([]);
        
  //       // Optional: Show a user-friendly message
  //       swal({
  //         title: "No Services",
  //         text: "No services are currently available.",
  //         icon: "info"
  //       });
  //     }
  //   } catch (error) {
  //     console.error('Error fetching services:', error);
      
  //     // Set empty array on error
  //     setServiceCategories([]);
      
  //     // Show error to user
  //     swal({
  //       title: "Error!",
  //       text: "Could not fetch services. Please try again later.",
  //       icon: "error"
  //     });
  //   }
  // };  
  // 1. First, update the fetchAllServiceInvoices function to include vendor information

  const fetchAllServiceInvoices = async () => {
    try {
      const response = await fetch(`${C.getUrl()}/service-invoice/getAllServiceInvoices`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
  
      if (!response.ok) {
        throw new Error('Failed to fetch services');
      }
  
      const data = await response.json();
      
      // Check if there are services
      if (data.subErrors && data.subErrors.length > 0) {
        // Parse the JSON string in subErrors
        const serviceItems = JSON.parse(data.subErrors[0]);
        
        // Group services by category
        const categorizedServices = serviceItems.reduce((acc, item) => {
          const categoryName = item.category;
          if (!acc[categoryName]) {
            acc[categoryName] = {
              name: categoryName,
              items: []
            };
          }
          
          // Store vendor information with each item
          // NOTE: Use "Vendor" with capital V as per your API response
          acc[categoryName].items.push({
            name: item.item,
            price: item.costPerUnit,
            vendor: item.Vendor || '' // Use "Vendor" with capital V
          });
          
          return acc;
        }, {});
  
        // Convert the grouped object to an array
        const serviceCategoriesList = Object.values(categorizedServices);
        setServiceCategories(serviceCategoriesList);
      } else {
        setServiceCategories([]);
        swal({
          title: "No Services",
          text: "No services are currently available.",
          icon: "info"
        });
      }
    } catch (error) {
      console.error('Error fetching services:', error);
      setServiceCategories([]);
      swal({
        title: "Error!",
        text: "Could not fetch services. Please try again later.",
        icon: "error"
      });
    }
  };

// Fetch vendors from API
const fetchVendors = async () => {
  console.log('Fetching vendors...');
  try {
    const url = `${C.getUrl()}/vendorMethod/getAllVendors`;
    console.log('API URL:', url);
    
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    console.log('Response status:', response.status);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error response:', errorText);
      throw new Error(`Failed to fetch vendors: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    console.log('API Response:', data);
    
    let vendorsList = [];
    
    if (data.subErrors && data.subErrors.length > 0) {
      console.log('Found vendors in subErrors');
      vendorsList = JSON.parse(data.subErrors[0]);
    } else if (data.statusCode === 200 && data.message) {
      console.log('Found vendors in message');
      vendorsList = JSON.parse(data.message);
    } else if (Array.isArray(data)) {
      console.log('Direct array response');
      vendorsList = data;
    } else {
      console.warn('Unexpected API response format:', data);
      vendorsList = [];
    }
    
    console.log('Parsed vendors:', vendorsList);
    setVendors(vendorsList);
    
    if (vendorsList.length === 0) {
      console.warn('No vendor data found in response');
    }
  } catch (error) {
    console.error('Error fetching vendors:', error);
    setVendors([
      { id: 1, venderName: 'PULSE DIAGNOSTIC' },
      { id: 2, venderName: 'JARIWALA LAB' }
    ]);
    
    swal({
      title: "Error!",
      text: `Could not fetch vendors: ${error.message}`,
      icon: "error"
    });
  }
};

  const fetchAllPackageInvoices = async () => {
    try {
      const response = await fetch(`${C.getUrl()}/package-invoice/getAllPackageInvoices`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
  
      if (!response.ok) {
        throw new Error('Failed to fetch packages');
      }
  
      const data = await response.json();
      
      // Check if there are any package invoices
      if (data.subErrors && data.subErrors.length > 0) {
        // Parse package items
        const packageItems = JSON.parse(data.subErrors[0]);
        
        const categorizedPackages = packageItems.reduce((acc, item) => {
          const categoryName = item.category;
          if (!acc[categoryName]) {
            acc[categoryName] = {
              name: categoryName,
              items: []
            };
          }
          
          acc[categoryName].items.push({
            name: item.item,
            price: item.costPerUnit
          });
          
          return acc;
        }, {});
  
        // Convert the grouped object to an array
        const packageCategoriesList = Object.values(categorizedPackages);
        
        setPackageCategories(packageCategoriesList);
      } else {
        // Set to empty array
        setPackageCategories([]);
        
        // Optional: Show a user-friendly message
        swal({
          title: "No Packages",
          text: "No packages are currently available.",
          icon: "info"
        });
      }
    } catch (error) {
      console.error('Error fetching packages:', error);
      
      // Set empty array on error
      setPackageCategories([]);
      
      // Show error to user
      swal({
        title: "Error!",
        text: "Could not fetch packages. Please try again later.",
        icon: "error"
      });
    }
  };



  // Add this function to both AddInvoice.js and EditInvoice.js
const calculateTotalItemDiscounts = () => {
  let totalItemDiscountAmount = 0;
  
  // Sum all item-specific discounts and convert to amount
  formState.selectedServices.forEach(service => {
    const price = service.item.price || 0;
    const quantity = service.item.quantity || 1;
    const baseTotal = price * quantity;
    const discountType = service.item.discountType || 'percentage';
    const discount = service.item.discount || 0;
    
    // Calculate discount amount based on type
    let discountAmount = 0;
    if (discountType === 'percentage') {
      discountAmount = (baseTotal * discount) / 100;
    } else {
      // Fixed amount
      discountAmount = Math.min(discount, baseTotal);
    }
    
    totalItemDiscountAmount += discountAmount;
  });
  
  return totalItemDiscountAmount;
};


  // const handleServiceSelect = (category, item) => {
  //   const newItem = {
  //     name: category.name,
  //     category: category.name,
  //     vendor: item.vendor || '',
  //     item: {
  //       name: item.name,
  //       price: item.price,
  //       quantity: 1,
  //       discount: 0,
  //       tax: 0,
  //       charges: item.price 
  //     }
  //   };
  
  //   setFormState(prev => {
  //     const currentItems = prev.selectedServices;
  //     const exists = currentItems.some(
  //       i => i.item.name === newItem.item.name && i.name === newItem.name
  //     );

  //     return {
  //       ...prev,
  //       selectedServices: exists 
  //         ? currentItems 
  //         : [...currentItems, newItem]
  //     };  
  //   });
  // };
  // 3. Update the handleServiceSelect function to include vendor info

  const handleServiceSelect = (category, item) => {
    const newItem = {
      name: category.name,
      category: category.name,
      vendor: item.vendor || '', // Make sure to include vendor information
      item: {
        name: item.name,
        price: item.price,
        quantity: 1,
        discount: 0,
        tax: 0,
        charges: item.price 
      }
    };
  
    setFormState(prev => {
      const currentItems = prev.selectedServices;
      const exists = currentItems.some(
        i => i.item.name === newItem.item.name && i.name === newItem.name
      );
  
      return {
        ...prev,
        selectedServices: exists 
          ? currentItems 
          : [...currentItems, newItem]
      };  
    });
  };



  const handleItemChange = (index, field, value) => {
    setFormState(prev => {
      const updatedServices = [...prev.selectedServices];
      
      // For nested item fields
      if (field.includes('.')) {
        const [parent, child] = field.split('.');
        updatedServices[index][parent] = {
          ...updatedServices[index][parent],
          [child]: value
        };
      } else {
        // For top-level fields
        updatedServices[index][field] = value;
      }
      
      // If changing discount, handle calculations based on discount type
      if (field === 'item.discount') {
        recalculateItemCharges(updatedServices, index, prev.showDiscount, prev.discountPercent);
      } 
      // If changing tax, we need to recalculate the charges
      else if (field === 'item.tax') {
        recalculateItemCharges(updatedServices, index, prev.showDiscount, prev.discountPercent);
      }
      // Recalculate if quantity or price changes
      else if (field === 'item.quantity' || field === 'item.price') {
        recalculateItemCharges(updatedServices, index, prev.showDiscount, prev.discountPercent);
      }
      
      return {
        ...prev,
        selectedServices: updatedServices
      };
    });
  };


  const recalculateItemCharges = (items, index, showGlobalDiscount, globalDiscountPercent) => {
    const item = items[index];
    const price = item.item.price || 0;
    const quantity = item.item.quantity || 1;
    const baseTotal = price * quantity;
    
    // First apply item-specific discount
    let discountAmount = 0;
    if (item.item.discount) {
      const discountType = item.item.discountType || 'percentage';
      
      if (discountType === 'percentage') {
        discountAmount = (baseTotal * item.item.discount) / 100;
      } else {
        // Fixed amount discount
        discountAmount = Math.min(item.item.discount, baseTotal);
      }
    }
    
    // Store the discount amount in rupees for later use
    item.item.totalDiscount = discountAmount.toFixed(2);
    
    // Calculate amount after discount but before tax
    const afterDiscountAmount = baseTotal - discountAmount;
    
    // Apply tax if any
    const taxRate = parseFloat(item.item.tax) || 0;
    const taxAmount = (afterDiscountAmount * taxRate) / 100;
    
    // Calculate final charges after discount and tax
    item.item.charges = afterDiscountAmount + taxAmount;
    
    // Ensure charges doesn't go negative
    if (item.item.charges < 0) item.item.charges = 0;
    
    return item;
  };
  

  const calculateTotalAmount = () => {
    const serviceTotal = formState.selectedServices.reduce(
      (sum, service) => sum + (service.item.price * (service.item.quantity || 1)), 0
    );
    const packageTotal = formState.selectedPackages.reduce(
      (sum, pkg) => sum + (pkg.item.price * (pkg.item.quantity || 1)), 0
    );
    return serviceTotal + packageTotal;
  };



  const calculateNetAmount = () => {
    // First calculate the subtotal after item-specific discounts and taxes
    let subtotal = 0;
    
    // Process service items with item-specific discounts first
    formState.selectedServices.forEach(service => {
      const price = service.item.price || 0;
      const quantity = service.item.quantity || 1;
      const baseTotal = price * quantity;
      let itemTotal = baseTotal;
      
      // Apply item-specific discount
      if (service.item.discount) {
        const discountType = service.item.discountType || 'percentage';
        
        if (discountType === 'percentage') {
          const discountAmount = (baseTotal * service.item.discount) / 100;
          itemTotal = baseTotal - discountAmount;
        } else {
          // Fixed amount discount
          itemTotal = baseTotal - Math.min(service.item.discount, baseTotal);
        }
      }
      
      // Add tax if applicable (on the discounted amount)
      const taxRate = parseFloat(service.item.tax) || 0;
      if (taxRate > 0) {
        itemTotal += (itemTotal * taxRate) / 100;
      }
      
      subtotal += itemTotal;
    });
    
    // Apply global discount to the subtotal
    let total = subtotal;
    
    if (formState.showDiscount) {
      if (formState.discountType === 'percentage' && formState.discountPercent) {
        const globalDiscountAmount = (subtotal * parseFloat(formState.discountPercent)) / 100;
        total = subtotal - globalDiscountAmount;
      } else if (formState.discountType === 'fixed' && formState.discountAmount) {
        total = subtotal - parseFloat(formState.discountAmount);
      }
    }
    
    // Ensure total doesn't go negative
    if (total < 0) total = 0;
    
    return total;
  };
  
  // Payment Method Handlers
  const updatePaymentMethod = (index, field, value) => {
    setFormState(prev => {
      const updatedPaymentMethods = [...prev.paymentMethods];
      updatedPaymentMethods[index] = {
        ...updatedPaymentMethods[index],
        [field]: value
      };
      return { ...prev, paymentMethods: updatedPaymentMethods };
    });
  };

  const addPaymentMethod = () => {
    setFormState(prev => ({
      ...prev,
      paymentMethods: [
        ...prev.paymentMethods, 
        { method: '', amount: '', note: '', date: '' }
      ]
    }));
  };

  // Item Removal Handlers
  const removeItem = (index) => {
    setFormState(prev => ({
      ...prev,
      selectedServices: prev.selectedServices.filter((_, i) => i !== index)
    }));
  };

  const clearAllItems = () => {
    setFormState(prev => ({
      ...prev,
      selectedServices: []
    }));
  };

  // Discount Handlers
  const toggleDiscount = () => {
    setFormState(prev => ({
      ...prev,
      showDiscount: !prev.showDiscount
    }));
  };

  // Rendering Logic
  // const renderServiceCategories = () => {
  //   const categories = formState.activeTab === 'services' 
  //     ? serviceCategories 
  //     : packageCategories;

  //   // Apply filters
  //   let filteredCategories = categories || [];
    
  //   if (formState.category) {
  //     filteredCategories = filteredCategories.filter(
  //       cat => cat.name.toLowerCase() === formState.category.toLowerCase()
  //     );
  //   }

  //   if (formState.searchTerm) {
  //     filteredCategories = filteredCategories.map(category => ({
  //       ...category,
  //       items: category.items.filter(item => 
  //         item.name.toLowerCase().includes(formState.searchTerm.toLowerCase())
  //       )
  //     })).filter(cat => cat.items.length > 0);
  //   }

  //   return filteredCategories;
  // };
// 2. Modify the renderServiceCategories function to filter by vendor

const renderServiceCategories = () => {
  const categories = formState.activeTab === 'services' 
    ? serviceCategories 
    : packageCategories;

  // Apply filters
  let filteredCategories = [...(categories || [])];
  
  // Apply category filter
  if (formState.category) {
    filteredCategories = filteredCategories.filter(
      cat => cat.name.toLowerCase() === formState.category.toLowerCase()
    );
  }

  // Apply vendor filter
  if (formState.vendor && formState.vendor.trim() !== '') {
    filteredCategories = filteredCategories.map(category => {
      return {
        ...category,
        items: (category.items || []).filter(item => {
          // Check if the item has a vendor property and it matches the selected vendor
          if (!item.vendor) return false;
          
          // Case-insensitive comparison with trimming
          return item.vendor.trim().toLowerCase() === formState.vendor.trim().toLowerCase();
        })
      };
    }).filter(cat => cat.items && cat.items.length > 0); // Only keep categories with matching items
  }

  // Apply search term filter
  if (formState.searchTerm) {
    filteredCategories = filteredCategories.map(category => ({
      ...category,
      items: (category.items || []).filter(item => 
        item.name.toLowerCase().includes(formState.searchTerm.toLowerCase())
      )
    })).filter(cat => cat.items && cat.items.length > 0);
  }

  return filteredCategories;
};

  const formatDateForAPI = (dateString) => {
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        // Handle invalid date
        return formatDateForAPI(new Date()); // Use current date as fallback
      }
      // Format as ISO string (yyyy-MM-dd'T'HH:mm:ss.SSS'Z')
      return date.toISOString();
    } catch (error) {
      console.error('Error formatting date:', error);
      // Return a default date in case of error
      const now = new Date();
      return now.toISOString();
    }
  };

// This is the updated saveInvoice function for AddInvoice.js to ensure discount handling consistency
const saveInvoice = async (status) => {
  // If paid status, always show discount fields without popup
  if (status === 'paid' && !formState.showDiscount) {
    setFormState(prev => ({
      ...prev,
      showDiscount: true
    }));
  }

  setFormSubmitted(true);
  // Reset all errors
  const newErrors = {
    invoiceDate: '',
    patientName: '',
    primaryConsultant: '',
    department: '',
    visitDate: ''
  };
  
  let isValid = true;
  
  // Validation checks remain the same...
  if (formState.selectedServices.length === 0) {
    swal({
      title: "Error!",
      text: "Please add at least one service to the invoice",
      icon: "error"
    });
    return;
  }
  
  if (!formState.invoiceDate) {
    newErrors.invoiceDate = 'Please fill up Invoice Date';
    isValid = false;
  }
  
  if (!formState.patientName) {
    newErrors.patientName = 'Please fill up Patient Name/ID';
    isValid = false;
  }
  
  if (!formState.primaryConsultant) {
    newErrors.primaryConsultant = 'Please fill up Primary Consultant';
    isValid = false;
  }
  
  if (!formState.department) {
    newErrors.department = 'Please fill up Department';
    isValid = false;
  }
  
  // Department-specific date validations
  if (formState.department === 'OPD' && !formState.visitDate) {
    newErrors.visitDate = 'Please fill up Visit Date';
    isValid = false;
  }
  
  if (formState.department === 'IPD' && !formState.admission_Date) {
    newErrors.admission_Date = 'Please fill up Admission Date';
    isValid = false;
  }
  
  // Update the errors state
  setErrors(newErrors);
  
  if (!isValid) {
    // Don't proceed if validation fails
    return;
  }

  // ADD THIS CODE HERE: Check if discount reason is provided when discount is enabled
  if (formState.showDiscount && !formState.discountReason) {
    swal({
      title: "Error!",
      text: "Please select a discount reason",
      icon: "error"
    });
    return;
  }
  // Additional validation only for Paid status...

  const patientId = formState.patientId ? 
    (isNaN(formState.patientId) ? 1001 : parseInt(formState.patientId)) : 
    1001;

  // Get doctorId from localStorage instead of hardcoded value
  const doctorId = localStorage.getItem("userId") || ""; 

  // Fetch patient details to get instituteName
  let instituteName = "MedCenter"; // Default value
  try {
    const patientResponse = await fetch(`${C.getUrl()}/userCase/getPatientDetail/${patientId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    
    if (patientResponse.ok) {
      const patientData = await patientResponse.json();
      instituteName = patientData.instituteName || "MedCenter";
    }
  } catch (error) {
    console.error("Error fetching patient details:", error);
  }
  
  // Create the payload structure with current timestamp for creation time
  const currentDateTime = new Date().toISOString();
  
  // UPDATED: Handle global discount based on type with consistent field names
  // Initialize all discount-related fields with appropriate default values
  let dpercentag = 0;
  let discountValue = 0;
  let invoicePType = "";
  let invoiceR = "";
  let invoiceRType = "";
  
  if (formState.showDiscount) {
    if (formState.discountType === 'percentage') {
      // Set percentage discount fields
      dpercentag = parseFloat(formState.discountPercent) || 0;
      invoicePType = "Percentage(%)";
      // Reset fixed amount fields to ensure they don't override
      discountValue = 0;
      invoiceR = "";
      invoiceRType = "";
    } else {
      // Set fixed amount discount fields
      discountValue = parseFloat(formState.discountAmount) || 0;
      invoiceR = discountValue.toString();
      invoiceRType = "Fixed amount";
      // Reset percentage fields to ensure they don't override
      dpercentag = 0;
      invoicePType = "";
    }
  } else {
    // If discount is disabled, reset all discount fields
    dpercentag = 0;
    discountValue = 0;
    invoicePType = "";
    invoiceR = "";
    invoiceRType = "";
  }

  const totalItemDiscountAmount = calculateTotalItemDiscounts();
  
// Calculate net amount and received amount
const netAmount = Number(calculateNetAmount());
let receivedAmount = 0;
let dueAmount = null; // Initialize to null

if (status === 'paid') {
  // For 'paid' status:
  // - Set received amount to equal the net amount
  // - Set due amount to null (don't show it)
  receivedAmount = netAmount;
  dueAmount = null;
} else {
  // For 'draft' or any other status:
  // - Calculate actual due amount
  // - Don't set any value for received amount (leave it at 0)
  receivedAmount = 0; // Don't set any received amount for draft
  dueAmount = netAmount; // Due is the full net amount
}

  const invoicePayload = {
    invoice: {
      patientName: formState.patientName,
      patientId: patientId,
      
      // UPDATED: Set both lowercase and uppercase versions of discount percentage
      // to ensure compatibility with different API endpoints
      dpercentag: dpercentag,  // lowercase - matches field in AddInvoice.js
      Dpercentag: dpercentag,  // uppercase - matches field in EditInvoice.js
      
      discount: discountValue,
      invoicePType: invoicePType,
      invoiceR: invoiceR,
      invoiceRType: invoiceRType,

      invoiceTotalDis: totalItemDiscountAmount.toFixed(2),
      invoiceDate: formatDateForAPI(formState.invoiceDate),
      createdDate: currentDateTime,
      createTime: currentDateTime,
      visitDate: formState.department === 'OPD' ? formatDateForAPI(formState.visitDate) : null,
      admission_Date: formState.department === 'IPD' ? formatDateForAPI(formState.admission_Date) : null,
      discharge_Date: formState.department === 'IPD' ? formatDateForAPI(formState.discharge_Date) : null,
      department: formState.department,
      status: status === 'paid' ? 'COMPLETED' : 'pending',
      netAmount: Number(calculateNetAmount()),
      received: formState.paymentMethods.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0),
      paymentDate: status === 'paid' ? currentDateTime : formatDateForAPI(formState.invoiceDate),
      primaryConsultant: formState.primaryConsultant,
      comments: formState.comments || '',
      createdBy: doctorId,
      updatedBy: doctorId,
      updateDate: currentDateTime,
      updateTime: currentDateTime,
      disResone: formState.discountReason || '',
      activeInd: "Y",
      // Add this field to the invoice object in invoicePayload
    due: dueAmount,
    },
    
    // UPDATED: Handle item-specific discount with proper field mapping
// Update inside the items mapping in saveInvoice function:
items: formState.selectedServices.map((service, index) => {
  const itemDiscount = service.item.discount || 0;
  const itemDiscountType = service.item.discountType || 'percentage';
  const itemPrice = Number(service.item.price || 0);
  const itemQuantity = Number(service.item.quantity || 1);
  
  // Set appropriate discount fields based on type
  let itemP = 0;
  let itemPType = "";
  let itemR = "0";
  let itemRType = "";
  
  if (itemDiscountType === 'percentage') {
    itemP = itemDiscount;
    itemPType = "%";
  } else {
    itemR = itemDiscount.toString();
    itemRType = "₹";
  }
  
  // Store the total discount amount in rupees
  const totalDiscount = service.item.totalDiscount || 
                        (itemDiscountType === 'percentage' ? 
                          ((itemPrice * itemQuantity * itemDiscount) / 100).toFixed(2) : 
                          itemDiscount.toString());
  
  return {
    costPerUnit: itemPrice,
    quantity: itemQuantity,
    // Standard discount field - stores the actual applied discount value
    discount: itemDiscount,
    // Store item's discount values properly mapped
    itemP: itemP,
    itemPType: itemPType,
    itemR: itemR,
    itemRType: itemRType,
    // Store total discount in rupees
    itemTotalDis: totalDiscount,
    
    tax: Number(service.item.tax || 0),
    charges: Number(service.item.charges || 0),
    category: service.name || `Service ${index + 1}`,
    item: service.item.name,
    netAmount: Number(service.item.charges || 0),
    patientId: patientId,
    createdBy: doctorId,
    updatedBy: doctorId,
    activeInd: "Y"
  };
}),
    // Payments handling
    payments: (status === 'paid' ? formState.paymentMethods.filter(payment => payment.method && payment.amount) : 
      formState.paymentMethods.filter(payment => payment.method && payment.amount))
      .map(payment => ({
        paymentMethod: payment.method,
        paymentAmount: Number(parseFloat(payment.amount || 0)),
        otherNote: payment.note || '',
        paymentDate: payment.date ? formatDateForAPI(payment.date) : formatDateForAPI(formState.invoiceDate),
        patientId: patientId,
        createdBy: doctorId
      })),
    instituteName: instituteName
  };

  // Log the payload for debugging
  console.log('Sending payload:', JSON.stringify(invoicePayload, null, 2));
  
  try {
    const response = await fetch(`${C.getUrl()}/invoice/save`, {
      method: 'PUT',
      headers: { 
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(invoicePayload)
    });

    if (!response.ok) {
      let errorText;
      try {
        errorText = await response.text();
        console.error('Full error response:', errorText);
      } catch (e) {
        errorText = `Status: ${response.status}`;
      }
      throw new Error(`HTTP error! ${errorText}`);
    }

    const responseData = await response.json();
    console.log('Response received:', responseData);

    swal({
      title: status === 'draft' ? "Draft Saved!" : "Success!",
      text: status === 'draft' 
        ? "Invoice saved as draft successfully" 
        : "Invoice saved successfully",
      icon: "success"
    });

    // Redirect to invoices list
    history.push('/invoices');
  } catch (error) {
    console.error('Detailed error:', error);
    swal({
      title: "Error!",
      text: error.message || 'An error occurred while saving the invoice',
      icon: "error"
    });
  }
}; 

return (
  <div className="d-flex" id="wrapper">
    <Side />
    <div id="content-wrapper" className="d-flex flex-column">
      <div id="content">
        <Top />
        <Container fluid>
          {formState.loading && <Loader />}
          
          {formState.error && (
            <div className="alert alert-danger m-3">
              {formState.error}
            </div>
          )}
          
          <div className="p-4">
            <Row>
              {/* Left column - Form fields and tables */}
              <Col md={8}>
                {/* Invoice Details Section */}
                <Row>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Invoice Date<span className="text-danger">*</span></Form.Label>
                      <Form.Control 
                        type="date"
                        name="invoiceDate"
                        value={formState.invoiceDate} 
                        onChange={handleChange}
                        min={getMinDate()}
                        isInvalid={!!errors.invoiceDate}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.invoiceDate}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                  <Form.Group>
  <Form.Label>Patient Name/ID <span className="text-danger">*</span></Form.Label>
  <div className="position-relative">
    <Form.Control 
      type="text"
      name="patientName"
      value={formState.patientName}
      onChange={handleChange}
      placeholder="Enter Patient Name/ID"
      isInvalid={!!errors.patientName}
    />
    {patientSearchResults.length > 0 && (
      <div className="position-absolute w-100 shadow rounded bg-white" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
        {patientSearchResults.map((patient, index) => (
          <div 
            key={index}
            className="p-2 border-bottom"
            onClick={() => selectPatient(patient)}
            style={{ cursor: 'pointer' }}
            onMouseOver={e => e.currentTarget.style.backgroundColor = '#f8f9fa'}
            onMouseOut={e => e.currentTarget.style.backgroundColor = 'white'}
          >
            <div><strong>{patient.patientName}</strong></div>
            <div className="small text-muted">Phone: {patient.phoneNumber} | Case ID: {patient.caseId}</div>
          </div>
        ))}
      </div>
    )}
    <Form.Control.Feedback type="invalid">
      {errors.patientName}
    </Form.Control.Feedback>
    {formState.patientId && (
      <small className="text-muted">Patient ID: {formState.patientId}</small>
    )}
  </div>
</Form.Group>
                  </Col>
                </Row>

                {/* Consultant and Department */}
                <Row className="mt-3">
                  <Col md={6}>
                  <Form.Group>
                    <Form.Label>Primary Consultant<span className="text-danger">*</span></Form.Label>
                    <Form.Control 
                      as="select"
                      name="primaryConsultant"
                      value={formState.primaryConsultant}
                      onChange={handleChange}
                      isInvalid={!!errors.primaryConsultant}
                    >
                      <option value="">Select Consultant</option>
                      {consultants.map((consultant, index) => (
                        <option key={index} value={consultant}>{consultant}</option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.primaryConsultant}
                    </Form.Control.Feedback>
                  </Form.Group>
                  </Col>
                  <Col md={6}>
                  <Form.Group>
                    <Form.Label>Department<span className="text-danger">*</span></Form.Label>
                    <Form.Control 
                      as="select"
                      name="department"
                      value={formState.department}
                      onChange={handleChange}
                      isInvalid={!!errors.department}
                    >
                      <option value="">Select Department</option>
                      {departments.map((dept, index) => (
                        <option key={index} value={dept}>{dept}</option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.department}
                    </Form.Control.Feedback>
                  </Form.Group>
                  </Col>
                </Row>
                
                {/* Visit Date Field */}
                  <Row className="mt-3">
                    {formState.department === 'OPD' && (
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Visit Date<span className="text-danger">*</span></Form.Label>
                          <Form.Control 
                            type="date"
                            name="visitDate"
                            value={formState.visitDate} 
                            onChange={handleChange}
                            min={getMinDate()}
                            isInvalid={!!errors.visitDate}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.visitDate}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    )}
                    
                    {formState.department === 'IPD' && (
                      <>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Admission Date<span className="text-danger">*</span></Form.Label>
                            <Form.Control 
                              type="date"
                              name="admission_Date"
                              value={formState.admission_Date || ''} 
                              onChange={handleChange}
                              min={getMinDate()}
                              isInvalid={!!errors.admission_Date}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.admission_Date}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Discharge Date</Form.Label>
                            <Form.Control 
                              type="date"
                              name="discharge_Date"
                              value={formState.discharge_Date || ''} 
                              onChange={handleChange}
                              min={formState.admission_Date || getMinDate()}
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )}
                    
                    {formState.department !== 'OPD' && formState.department !== 'IPD' && formState.department && (
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Visit Date<span className="text-danger">*</span></Form.Label>
                          <Form.Control 
                            type="date"
                            name="visitDate"
                            value={formState.visitDate} 
                            onChange={handleChange}
                            min={getMinDate()}
                            isInvalid={!!errors.visitDate}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.visitDate}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    )}
                  </Row>

                {/* Items Table */}
                <Row className="mt-3">
                  <Col>
                    <Table striped bordered hover responsive>
                      <thead className="table-header-font">
                        <tr>
                          <th>ITEM</th>
                          <th>COST PER UNIT (₹)</th>
                          <th>QTY</th>
                          <th>DISCOUNT</th>
                          <th>TAX (%)</th>
                          <th>CHARGES (₹)</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* {formState.selectedServices.map((service, index) => (
                          <tr key={index}>
                            <td>
                              <div>{service.item.name}</div>
                              <div className="small text-muted">
                                Category: {service.category || service.name}
                                {service.Vendor && ` | Vendor: ${service.Vendor}`}
                              </div>
                            </td>
                            <td>
                              <Form.Control 
                                type="number"
                                min="0"
                                value={service.item.price || 0}
                                onChange={(e) => handleItemChange(index, 'item.price', parseFloat(e.target.value) || 0)}
                                style={{ width: '100px' }}
                              />
                            </td> */}
   {formState.selectedServices.map((service, index) => (
  <tr key={index}>
    <td>
      <div>{service.item.name}</div>
      <div className="small text-muted">
        Category: {service.category || service.name}
        {service.vendor && service.vendor.trim() !== '' ? ` | Vendor: ${service.vendor}` : ''}
      </div>
    </td>
    <td>
      <Form.Control 
        type="number"
        min="0"
        value={service.item.price || 0}
        onChange={(e) => handleItemChange(index, 'item.price', parseFloat(e.target.value) || 0)}
        style={{ width: '100px' }}
      />
    </td>
                            <td>
                              <Form.Control 
                                type="number"
                                min="1"
                                value={service.item.quantity || 1}
                                onChange={(e) => handleItemChange(index, 'item.quantity', parseInt(e.target.value) || 1)}
                                style={{ width: '70px' }}
                              />
                            </td>
                            <td>
                              <InputGroup className="mb-0">
                                <Form.Control
                                  type="number"
                                  min="0"
                                  value={service.item.discount || 0}
                                  onChange={(e) => handleItemChange(index, 'item.discount', parseFloat(e.target.value) || 0)}
                                  style={{ width: '70px' }}
                                />
                                <InputGroup.Append>
                                  <Form.Control
                                    as="select"
                                    value={service.item.discountType || 'percentage'}
                                    onChange={(e) => handleItemDiscountTypeChange(index, e.target.value)}
                                    style={{ width: '60px' }}
                                  >
                                    <option value="percentage">%</option>
                                    <option value="fixed">₹</option>
                                  </Form.Control>
                                </InputGroup.Append>
                              </InputGroup>
                            </td>
                            <td>
                              <Form.Control 
                                type="number"
                                min="0"
                                max="100"
                                value={service.item.tax || 0}
                                onChange={(e) => handleItemChange(index, 'item.tax', parseFloat(e.target.value) || 0)}
                                style={{ width: '70px' }}
                              />
                            </td>
                            <td>
                              {service.item.charges ? service.item.charges.toFixed(2) : 
                                ((service.item.price || 0) * (service.item.quantity || 1)).toFixed(2)}
                            </td>
                            <td>
                              <Button 
                                variant="danger" 
                                size="sm"
                                onClick={() => removeItem(index)}
                              >
                                Remove
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      {formState.selectedServices.length > 0 && (
                        <tfoot>
                          <tr>
                            <td colSpan="5" className="text-right font-weight-bold">
                              Net Amount
                            </td>
                            <td className="font-weight-bold">₹{calculateNetAmount().toFixed(2)}</td>
                            <td></td>
                          </tr>
                        </tfoot>
                      )}
                    </Table>
                  
                    {/* Modified Global Discount Section */}
                    {formState.showDiscount ? (
                      <div className="border p-3 mb-3">
                        <Row>
                          <Col md={2}>
                            <Button 
                              variant="link" 
                              className="text-danger p-0" 
                              onClick={toggleDiscount}
                            >
                              Remove Discount
                            </Button>
                          </Col>
                          <Col md={2}>
                            <Form.Group>
                              <Form.Label>Discount Type</Form.Label>
                              <Form.Control
                                as="select"
                                value={formState.discountType}
                                onChange={(e) => handleDiscountTypeChange(e.target.value)}
                              >
                                <option value="percentage">Percentage (%)</option>
                                <option value="fixed">Fixed Amount (₹)</option>
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          {formState.discountType === 'percentage' ? (
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label>Discount Percentage</Form.Label>
                                <InputGroup>
                                  <Form.Control
                                    type="number"
                                    placeholder="0"
                                    name="discountPercent"
                                    value={formState.discountPercent}
                                    onChange={handleChange}
                                    min="0"
                                    max="100"
                                  />
                                  <InputGroup.Append>
                                    <InputGroup.Text>%</InputGroup.Text>
                                  </InputGroup.Append>
                                </InputGroup>
                              </Form.Group>
                            </Col>
                          ) : (
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label>Discount Amount</Form.Label>
                                <InputGroup>
                                  <InputGroup.Prepend>
                                    <InputGroup.Text>₹</InputGroup.Text>
                                  </InputGroup.Prepend>
                                  <Form.Control
                                    type="number"
                                    placeholder="Amount"
                                    name="discountAmount"
                                    value={formState.discountAmount}
                                    onChange={handleChange}
                                    min="0"
                                  />
                                </InputGroup>
                              </Form.Group>
                            </Col>
                          )}
                          <Col md={3}>
                            <Form.Group>
                              {/* <Form.Label>Discount Reason <span className="text-danger">*</span></Form.Label> */}
                              <Form.Label>Discount Reason {formState.showDiscount ? <span className="text-danger">*</span> : ''}</Form.Label>
                              <Form.Control
                                as="select"
                                name="discountReason"
                                value={formState.discountReason}
                                onChange={handleChange}
                                className={formState.showDiscount && !formState.discountReason ? "border-danger" : ""}
                              >
                                <option value="">Select Reason</option>
                                {discountReasons.map((reason, index) => (
                                  <option key={index} value={reason}>{reason}</option>
                                ))}
                              </Form.Control>
                              {formState.showDiscount && !formState.discountReason && (
                                <small className="text-danger">Please select a discount reason</small>
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-between">
                        <Button variant="link" onClick={toggleDiscount}>
                          Add Discount
                        </Button>
                        {formState.selectedServices.length > 0 && (
                          <Button 
                            variant="outline-danger" 
                            size="sm"
                            onClick={clearAllItems}
                          >
                            Clear All Items
                          </Button>
                        )}
                      </div>
                    )}
                  </Col>
                </Row>

                {/* Payment Methods */}
                <Row className="mt-3">
                  <Col>
                    <div className="d-flex justify-content-between mb-2">
                      {formState.paymentMethods.length > 0 && 
                      formState.paymentMethods.some(p => p.method || p.amount || p.note || p.date) && (
                        <Button 
                          variant="outline-danger" 
                          size="sm"
                          onClick={() => {
                            // Reset to default single payment method
                            setFormState(prev => ({
                              ...prev,
                              paymentMethods: [{ 
                                method: '', 
                                amount: '', 
                                note: '', 
                                date: '' 
                              }]
                            }));
                          }}
                        >
                          Clear All Payments
                        </Button>
                      )}
                    </div>
                    
                    <Table striped bordered hover responsive>
                      <thead className="table-header-font">
                        <tr>
                          <th>#</th>
                          <th>PAYMENT METHOD <span className="text-danger">*</span></th>
                          <th>PAYMENT AMOUNT <span className="text-danger">*</span></th>
                          <th>OTHER NOTE</th>
                          <th>PAYMENT DATE</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                      {formState.paymentMethods.map((payment, index) => (
  <tr key={index}>
    <td>{index + 1}</td>
    <td>
      <Form.Control 
        as="select"
        value={payment.method}
        onChange={(e) => updatePaymentMethod(index, 'method', e.target.value)}
        className={formSubmitted && !payment.method ? "border-danger" : ""}
      >
        <option value="">Select</option>
        {paymentMethodOptions.map((method, idx) => (
          <option key={idx} value={method}>{method}</option>
        ))}
      </Form.Control>
      {formSubmitted && !payment.method && (
        <small className="text-danger">Payment method is required</small>
      )}
    </td>
    <td>
      <Form.Control 
        type="number"
        value={payment.amount}
        onChange={(e) => updatePaymentMethod(index, 'amount', e.target.value)}
        placeholder="Amount"
        className={formSubmitted && !payment.amount ? "border-danger" : ""}
      />
      {formSubmitted && !payment.amount && (
        <small className="text-danger">Payment amount is required</small>
      )}
    </td>
                            <td>
                              <Form.Control 
                                type="text"
                                value={payment.note}
                                onChange={(e) => updatePaymentMethod(index, 'note', e.target.value)}
                                placeholder="Notes"
                              />
                            </td>
                            <td>
                              <Form.Control 
                                type="date"
                                value={payment.date}
                                onChange={(e) => updatePaymentMethod(index, 'date', e.target.value)}
                                min={getMinDate()}
                              />
                            </td>
                            <td>
                              {index !== 0 ? (
                                <Button 
                                  variant="danger" 
                                  size="sm"
                                  onClick={() => {
                                    setFormState(prev => ({
                                      ...prev,
                                      paymentMethods: prev.paymentMethods.filter((_, i) => i !== index)
                                    }));
                                  }}
                                >
                                  Remove
                                </Button>
                              ) : (
                                <Button 
                                  variant="outline-secondary" 
                                  size="sm"
                                  onClick={() => {
                                    // Clear only the first row's data
                                    setFormState(prev => {
                                      const updatedPaymentMethods = [...prev.paymentMethods];
                                      updatedPaymentMethods[0] = { 
                                        method: '', 
                                        amount: '', 
                                        note: '', 
                                        date: '' 
                                      };
                                      return {
                                        ...prev,
                                        paymentMethods: updatedPaymentMethods
                                      };
                                    });
                                  }}
                                >
                                  Clear
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    
                    {/* Add Payment button */}
                    <div className="d-flex justify-content-start mt-2">
                      <Button 
                        variant="outline-primary"
                        onClick={addPaymentMethod}
                      >
                        Add Payment Method
                      </Button>
                    </div>
                  </Col>
                </Row>

                {/* Comments Section */}
                <Row className="mt-3">
                  <Col>
                    <Form.Group>
                      <Form.Label>Comments, Notes and Special Instructions</Form.Label>
                      <Form.Control 
                        as="textarea" 
                        rows={3}
                        name="comments"
                        value={formState.comments}
                        onChange={handleChange}
                        placeholder="Enter any additional comments or instructions"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Action Buttons */}
                <Row className="mt-3">
                  <Col className="d-flex justify-content-end">
                    <Button 
                      variant="outline-secondary" 
                      className="mr-2"
                      onClick={() => history.push('/invoices')}
                    >
                      Cancel
                    </Button>
                    <Button 
                      variant="outline-primary" 
                      className="mr-2"
                      onClick={() => saveInvoice('draft')}
                    >
                      Save As Draft
                    </Button>
                    <Button 
                      variant="primary"
                      onClick={() => saveInvoice('paid')}
                      style={{ backgroundColor: '#5ABDA3', color: 'white' }}
                    >
                      Save As Paid
                    </Button>
                  </Col>
                </Row>
              </Col>
              
              {/* Right column - Services/Packages Selection Section */}
              <Col md={4}>
                <Nav variant="tabs" activeKey={formState.activeTab}>
                  <Nav.Item>
                    <Nav.Link 
                      eventKey="services"
                      onClick={() => setFormState(prev => ({ ...prev, activeTab: 'services' }))}
                    >
                      By Services
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link 
                      eventKey="packages"
                      onClick={() => setFormState(prev => ({ ...prev, activeTab: 'packages' }))}
                    >
                      By Packages
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                
             
                {/* Filtering and Search Section - Only for Packages tab */}
{formState.activeTab === 'packages' && (
  <Row className="my-3">
    <Col>
      <InputGroup>
        <Form.Control 
          type="text"
          placeholder="Search packages..."
          name="searchTerm"
          value={formState.searchTerm}
          onChange={handleChange}
        />
        <InputGroup.Append>
          <Button variant="outline-secondary">
            <FaSearch />
          </Button>
        </InputGroup.Append>
      </InputGroup>
    </Col>
  </Row>
)}

{/* Filtering and Search Section - Only for Services tab */}
{formState.activeTab === 'services' && (
  <>
    <Row className="mb-3">
      <Col md={6} className="pr-1">
        <Form.Control 
          as="select"
          name="category"
          value={formState.category}
          onChange={handleChange}
          className="form-control border-primary rounded"
        >
          <option value="">Select Category</option>
          {serviceCategories.map((cat, index) => (
            <option key={index} value={cat.name}>{cat.name}</option>
          ))}
        </Form.Control>
      </Col>
      <Col md={6} className="pl-1">
        <Form.Control 
          as="select"
          name="billingClass"
          value={formState.billingClass}
          onChange={handleChange}
          className="form-control"
        >
          <option value="">Select Billing Class</option>
          <option value="class1">OPD</option>
          <option value="class2">UNIPATH LAB</option>
          <option value="class3">DAY CARE</option>
          <option value="class4">ECONOMY</option>
          <option value="class5">DELUXE</option>
          <option value="class6">DAY CARE WARD</option>
        </Form.Control>
      </Col>
    </Row>

    <Row className="mb-2">
    
      <Col md={6} className="pl-1">
        <Form.Control 
          as="select"
          name="vendor"
          value={formState.vendor}
          onChange={handleChange}
          className="form-control"
        >
          <option value="">Select Vendor</option>
          {vendors.map((vendor) => (
            <option key={vendor.id} value={vendor.venderName}>
              {vendor.venderName}
            </option>
          ))}
        </Form.Control>
      </Col>
      <Col md={6} className="pl-1">
        <InputGroup>
          <Form.Control
            type="text"
            placeholder="Search Item"
            name="searchTerm"
            value={formState.searchTerm}
            onChange={handleChange}
          />
          <InputGroup.Append>
            <Button variant="outline-secondary">
              <FaSearch />
            </Button>
          </InputGroup.Append>
        </InputGroup>
      </Col>
    </Row>
  </>
)}

{/* Categories and Items Display */}
<div style={{ maxHeight: '500px', overflowY: 'auto' }}>
{formState.activeTab === 'services' ? (
  renderServiceCategories().map((category, index) => (
    <Card key={index} className="mb-2">
      <Card.Header>{category.name}</Card.Header>
      <Card.Body className="p-0">
        <ListGroup variant="flush">
          {category.items && category.items.map((item, itemIndex) => (
            <ListGroup.Item 
              key={itemIndex}
              action
              onClick={() => handleServiceSelect(category, item)}
              className="d-flex justify-content-between align-items-center"
            >
              <div>
                <div>{item.name}</div>
                {item.vendor && item.vendor.trim() !== '' && (
                  <small className="text-muted">Vendor: {item.vendor}</small>
                )}
              </div>
              <Badge variant="primary">₹{item.price}</Badge>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Card.Body>
    </Card>
  ))
) : (
  // Original package rendering code remains unchanged
  renderPackageHeadings().map((packageGroup, index) => (
    <Card key={index} className="mb-2">
      <Card.Header 
        className="d-flex justify-content-between align-items-center"
        style={{ cursor: 'pointer' }}
        onClick={() => handleSelectAllPackages(packageGroup.heading, packageGroup.items)}
      >
        <div>{packageGroup.heading}</div>
        <Badge variant="primary">{packageGroup.items.length} items</Badge>
      </Card.Header>
    </Card>
  ))
)}
</div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  </div>
);
};

export default AddInvoice;